import axios from 'axios';
import Api from './Api';

const { CancelToken } = axios;
let cancelRead;
class TruckScheduleRequestApi extends Api {
  constructor() {
    super('truck-schedules/requests', 'truck-schedules/requests');
  }

  async store(data, url = null, options = {}, errorCallback = null) {
    try {
      const response = await axios.post(`/${this.endpoint}${url ? `/${url}` : ''}`, data, options);
      return response.data;
    } catch (error) {
      if (errorCallback) {
        errorCallback(error);
      }
      throw error;
    }
  }

  async update(data, url = null) {
    const response = await axios.put(`/${this.endpoint}${url ? `/${url}` : ''}`, data);
    return response.data;
  }

  async readRequests(data) {
    if (cancelRead !== undefined) {
      cancelRead();
    }
    const res = await this.read(data, {
      cancelToken: new CancelToken((c) => {
        cancelRead = c;
      }),
    });
    return res;
  }
}
const truckScheduleRequestApi = new TruckScheduleRequestApi();

export default truckScheduleRequestApi;
